<template>
<div class="chapter">
<div class="inner_page">
<p class="C96"><a id="page_vii">CONTENTS</a></p><a id="page_vii">
</a><p class="C97"><a id="page_vii"><em></em></a><em><a href="#/xhtml/06_A_Note_on_the_Title#page_ix">A Note on the Title</a></em></p>
<p class="C97"><em><a href="#/xhtml/07_Acknowledgments#page_xi">Acknowledgments</a></em></p>
<p class="C97"><em><a href="#/xhtml/08_A_Novelist_Reads_the_Talmud__An#page_xiii">A Novelist Reads the Talmud: An Introduction</a></em></p>
<p class="C100"><em><a href="#/xhtml/09_Timeline_of_Relevant_Events__Acc#page_xxi">Timeline of Relevant Events, According to Rabbinic Tradition</a></em></p>
<p class="C97"><a href="#/xhtml/10_MEMO_ONE__Rabbi_Yohanan_and_Rabb#page_1">MEMO ONE. Rabbi Yohanan and Rabbi Shimon ben Lakish</a></p>
<p class="C97"><a href="#/xhtml/11_CHAPTER_1__Eros_and_Alchemy_in_t#page_3">CHAPTER 1. Eros and Alchemy in the Waters of the Jordan</a></p>
<p class="C97"><span href="#/xhtml/12_MEMO_TWO__Rabbi_Shimon_bar_Yohai#page_41" title="Link target outside of Sample">MEMO TWO. Rabbi Shimon bar Yohai</span></p>
<p class="C97"><span href="#/xhtml/13_CHAPTER_2__Turning_the_Hearts_of#page_44" title="Link target outside of Sample">CHAPTER 2. Turning the Hearts of Fathers</span></p>
<p class="C97"><span href="#/xhtml/14_MEMO_THREE_A__B__AND_C__Rabbi_El#page_75" title="Link target outside of Sample">MEMO THREE A, B, AND C. Rabbi Elazar ben Rabbi Shimon, Rabbi Pinhas ben Yair, and Rabbi Judah ben Gerim</span></p>
<p class="C97"><span href="#/xhtml/15_CHAPTER_3__Towards_the_Hearts_of#page_82" title="Link target outside of Sample">CHAPTER 3. Towards the Hearts of Sons</span></p>
<p class="C97"><span href="#/xhtml/16_MEMO_FOUR__Rabban_Gamliel_II_of#page_117" title="Link target outside of Sample">MEMO FOUR. Rabban Gamliel II of Yavneh, Rabbi Joshua ben Hananiah, and Rabbi Eliezer ben Hyrcanus</span></p>
<p class="C97"><span href="#/xhtml/17_CHAPTER_4__The_Gate_of_a_Broken#page_124" title="Link target outside of Sample">CHAPTER 4. The Gate of a Broken Heart</span></p>
<p class="C97"><span href="#/xhtml/18_MEMO_FIVE__Rabbi_Akiva__Shimon_b#page_169" title="Link target outside of Sample">MEMO FIVE. Rabbi Akiva, Shimon ben Azzai, Shimon ben Zoma, and Elisha ben Avuyah</span></p>
<p class="C100"><span href="#/xhtml/19_CHAPTER_5__Revelation__Retributi#page_170" title="Link target outside of Sample">CHAPTER 5. Revelation, Retribution, Perdition, Ecstasy, and Bliss: An Epic Canvas</span></p>
<p class="C97"><em><span href="#/xhtml/20_Endnotes#page_219" title="Link target outside of Sample">Endnotes</span></em></p>
<p class="C97"><em><span href="#/xhtml/21_Glossary#page_235" title="Link target outside of Sample">Glossary</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?720bcf5c